/* eslint-disable consistent-return */
type MP = typeof import("mixpanel-browser").default
let ready: Promise<MP> | null = null

export const Analytics = new Proxy<Record<string, any>>(
  {},
  {
    get(_, prop: string) {
      // Special‑case the init() call
      if (prop === "init") {
        return (token: string, config?: Parameters<MP["init"]>[1]) => {
          if (!ready) {
            ready = import("mixpanel-browser").then((mod) => {
              const mp = mod.default
              mp.init(token, config)
              return mp
            })
          }
          return ready
        }
      }

      // For any other property/method
      return (...args: any[]) => {
        if (!ready) {
          console.warn(`Mixpanel not initialised—dropping call to [${prop}]`, ...args)
          return
        }
        return ready.then((mp) => {
          const fn = (mp as any)[prop]
          if (typeof fn === "function") {
            return fn.apply(mp, args)
          }
          return fn
        })
      }
    },
  }
) as MP & { init: (token: string, config?: any) => Promise<MP> }
export default Analytics
